



























































































import { ClientAccountsApi } from '@/api/client-accounts';
import loading from '@/components/loading.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientAccountDeed } from '@/shared/clients/client-account-deed';
import { ClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { ClientOriginalSourceType } from '@/shared/types/client-original-source-type';
import { PowerOfAttorneyType } from '@/shared/types/power-of-attorney-type';
import { WillType } from '@/shared/types/will-type';
import uniqueId from 'lodash.uniqueid';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');
const clientApi = new ClientAccountsApi();

@Component({
    components: {
        loading,
    },
})
export default class ClientMergeDetailWithLookup extends Vue {
    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('clientOriginalSourceTypes') private clientOriginalSourceTypes!: Array<ClientOriginalSourceType>;
    @typesModule.Getter('powerOfAttorneyTypes') private powerOfAttorneyTypes!: Array<PowerOfAttorneyType>;
    @typesModule.Getter('willTypes') private willTypes!: Array<WillType>;

    @Prop({ required: true }) private client!: ClientAccount | null;
    @Prop({ required: true }) private headerText!: string;

    private pluginId: string = uniqueId();
    private isSearchRunning: boolean = false;
    private accountNo: number | null = null;
    private selectedClient: ClientAccount | null = this.client;

    private get showDocuments(): boolean {
        return this.selectedClient == null
            ? false
            : this.selectedClient.will != null || this.selectedClient.powerOfAttorneys.length > 0 || this.selectedClient.factFind != null || this.selectedClient.deeds.length > 0;
    }

    private get clientName(): string {
        return this.selectedClient == null
            ? ''
            : `${this.selectedClient.firstName == null ? '' : this.selectedClient.firstName.trim()} ${this.selectedClient.lastName == null ? '' : this.selectedClient.lastName.trim()}`;
    }

    private get clientOriginalSourceTypeDescription(): string {
        if (this.selectedClient == null || this.selectedClient.originalSourceId == null) {
            return '';
        }

        const clientOriginalSourceType = this.clientOriginalSourceTypes.find((type) => type.id === this.selectedClient!.originalSourceId);
        return clientOriginalSourceType == null ? '' : clientOriginalSourceType.value;
    }

    private get willTypeDescription(): string {
        if (this.selectedClient == null || this.selectedClient.will == null) {
            return '';
        }

        const willType = this.willTypes.find((type) => type.id === this.selectedClient!.will!.willTypeId);
        return willType == null ? '' : willType.value;
    }

    @Watch('client')
    private onClientChanged(client: ClientAccount | null): void {
        this.selectedClient = client;
    }

    private powerOfAttorneyTypeDescription(powerOfAttorney: ClientPowerOfAttorney): string {
        const powerOfAttorneyType = this.powerOfAttorneyTypes.find((type) => type.id === powerOfAttorney.powerOfAttorneyTypeId);
        return powerOfAttorneyType == null ? '' : powerOfAttorneyType.value;
    }

    private deedDescription(deed: ClientAccountDeed): string {
        return `Deed - ${deed.addressLine1}, ${deed.postcode}`;
    }

    private async onSearchAsync(): Promise<void> {
        if (!(await this.$validator.validateAll('client-details'))) {
            return;
        }

        this.isSearchRunning = true;

        try {
            this.selectedClient = await clientApi.getClientAccountByAccountNumberAsync(this.accountNo!);
            this.$emit('client-changed', { ...this.selectedClient });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not find details for account '${this.accountNo!}', please try again.`, type: 'is-danger' });
            }
        }

        this.isSearchRunning = false;
    }

    private onClear(): void {
        this.accountNo = null;
        this.selectedClient = null;
        this.$emit('client-changed', null);
        this.$validator.errors.clear('client-details');
    }
}
